<form (change)=saveForm() [formGroup]="premieLijfrente">
    <div *ngIf="betaaldePremieLijfrente.length > 0" class="row">
        <div formArrayName="betaaldePremieLijfrente">
            <div *ngFor="let item of betaaldePremieLijfrente.controls; let i = index;"
                 [formGroupName]="i" class="row">
                <div class="col-auto row">
                    <snelstart-ui-text-form-control (change)="saveForm()"
                                                    [label]="i === 0 ? 'Omschrijving premie lijfrente' : ''"
                                                    class="custom-input-250 col-auto"
                                                    formControlName="omschrijving"
                                                    id="omschrijving"
                    >
                    </snelstart-ui-text-form-control>
                    <snelstart-ui-text-form-control (change)="saveForm()"
                                                    [label]="i === 0 ? 'Polisnummer' : ''"
                                                    class="custom-input-200 col-auto"
                                                    formControlName="polisnummer"
                                                    id="polisnummer"
                    >
                    </snelstart-ui-text-form-control>
                    <snelstart-ui-number-form-control (change)="saveForm()"
                                                      [decimals]="0"
                                                      [label]="i === 0 ? 'Bedrag' : ''"
                                                      align="right"
                                                      class="custom-input-150 col-auto"
                                                      formControlName="bedrag"
                                                      id="bedragLijfrente"
                                                      prefix="€"
                    >
                    </snelstart-ui-number-form-control>
                </div>

                <div class="col-auto">
                    <snelstart-ui-button (click)="verwijderRijPremieLijfrente(i)"
                                         [class]="i === 0 ? 'firstrowbutton col-auto' : 'col-auto'"
                                         icon="trash"
                                         iconType="light"
                                         id="buttonDeleteKosten"
                                         size="medium"
                                         icon="trash"
                                         type="secondary"
                    >
                    </snelstart-ui-button>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="betaaldePremieLijfrente.length === 0">
        <snelstart-ui-button (click)="addRijPremieLijfrente()" class="snelstart-ui-button" icon="plus"
                             type="link">Betaalde premie invullen
        </snelstart-ui-button>
    </div>

    <div *ngIf="betaaldePremieLijfrente.length > 0">
        <snelstart-ui-button (click)="addRijPremieLijfrente()" class="snelstart-ui-button" icon="plus"
                             type="link">Betaalde premie toevoegen
        </snelstart-ui-button>
    </div>

    <div *ngIf="heeftWinst">
        <div *ngIf="betaaldePremieLijfrenteFor.length > 0" class="row pt-5">
            <ng-container formArrayName="lijfrentePremiesFOR">
                <ng-container *ngFor="let item of betaaldePremieLijfrenteFor.controls; let j = index;"
                              [formGroupName]="j" class="row">
                    <div class="col-auto row">
                        <snelstart-ui-select-form-control
                                (change)="saveForm()"
                                [class]="'me-1 custom-input-250'"
                                [label]="j === 0 ? 'Premie FOR/stakingswinst' : ''"
                                [options]="omschrijvingLijfrente"
                                formControlName="omschrijving"
                                id="omschrijvingLr"
                        >
                        </snelstart-ui-select-form-control>
                        <snelstart-ui-text-form-control (change)="saveForm()"
                                                        [label]="j === 0 ? 'Polisnummer' : ''"
                                                        class="custom-input-200"
                                                        formControlName="polisnummer"
                                                        id="polisnummer"
                        >
                        </snelstart-ui-text-form-control>
                        <snelstart-ui-number-form-control (change)="saveForm()"
                                                          [decimals]="0"
                                                          [label]="j === 0 ? 'Bedrag' : ''"
                                                          [required]=true
                                                          align="right"
                                                          class="custom-input-150"
                                                          formControlName="bedrag"
                                                          id="betaaldePremieLijfrenteFor"
                                                          prefix="€"
                        >
                        </snelstart-ui-number-form-control>
                        <snelstart-ui-button (click)="verwijderRijPremieLijfrenteFor(j)"
                                             [class]="j === 0 ? 'firstrowbutton col-auto' : 'col-auto'"
                                             class="delete"
                                             icon="trash"
                                             iconType="light"
                                             id="buttonDeleteKostenFor"
                                             size="medium"
                                             type="secondary"
                        >
                        </snelstart-ui-button>
                    </div>
                </ng-container>
            </ng-container>
        </div>
    </div>

</form>

<div *ngIf="heeftWinst">
    <div *ngIf="betaaldePremieLijfrenteFor.length === 0" class="pt-5">
        <snelstart-ui-button (click)="addRijPremieLijfrenteFor()" class="snelstart-ui-button" icon="plus"
                             type="link">Betaalde premie i.v.m. afname FOR/stakingswinst
            invullen
        </snelstart-ui-button>
    </div>
    <div *ngIf="betaaldePremieLijfrenteFor.length > 0">
        <snelstart-ui-button (click)="addRijPremieLijfrenteFor()" class="snelstart-ui-button" icon="plus"
                             type="link">Betaalde premie i.v.m. afname FOR/stakingswinst
            toevoegen
        </snelstart-ui-button>
    </div>
</div>


